import { render, staticRenderFns } from "./onMounted-editor.vue?vue&type=template&id=47774d36&scoped=true"
import script from "./onMounted-editor.vue?vue&type=script&lang=js"
export * from "./onMounted-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47774d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47774d36')) {
      api.createRecord('47774d36', component.options)
    } else {
      api.reload('47774d36', component.options)
    }
    module.hot.accept("./onMounted-editor.vue?vue&type=template&id=47774d36&scoped=true", function () {
      api.rerender('47774d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onMounted-editor.vue"
export default component.exports